import { Field, Form, Formik } from 'formik';
import React, { Fragment, useCallback, useState } from 'react';
import background from './resetPass.svg';
import InputField from 'customField/InputField';
import NewDesign from 'components/NewDesign';
import { useHistory } from 'react-router';
import services from 'services';
import { isResponseSuccess } from 'helpers';
import { validationResetPassword } from 'consts/validateSchema';
import { V2_RESET_PASSWORD_URL } from 'consts/api';
import { AppRoutes } from 'consts/routesPath';
import { useQueryParam } from 'hooks/useQueryParam';

const initialValues = {
  password: '',
  passwordConfirm: '',
};

const ResetPasswordV2 = () => {
  //! State
  const [state, setState] = useState({
    success: null,
    error: null,
  });

  const params = useQueryParam();
  const token = params?.token;
  const needResetPassword = params?.required === 'true';

  const { error, success } = state;
  const history = useHistory();

  //! Function
  const handleOnSubmit = useCallback(
    async (values, { setSubmitting, resetForm }) => {
      if (values.password !== values.passwordConfirm) {
        setState((prev) => ({ ...prev, error: 'Confirm password not matched' }));
        return;
      }

      const requestBody = JSON.parse(JSON.stringify(values));
      delete requestBody.passwordConfirm;
      requestBody.token = token;
      setState((prev) => ({ ...prev, error: null }));
      try {
        const res = await services.post(V2_RESET_PASSWORD_URL, requestBody);
        if (isResponseSuccess(res.status) && res.data && res.data.status === 'success') {
          setState((prev) => ({ ...prev, success: true }));
          await new Promise((resolve) => setTimeout(resolve, 1500));
          window.location.href = AppRoutes.Login;
        } else {
          throw Error(res?.data?.error?.error || 'No response');
        }
      } catch (error) {
        try {
          setState((prev) => ({ ...prev, error: JSON.parse(error).error }));
        } catch (e) {
          setState((prev) => ({ ...prev, error: error.toString() }));
        }
      }

      setSubmitting(false);
    },
    [token, history],
  );

  //! Render
  return (
    <Fragment>
      <div className='center flex-column login_page'>
        <div
          className='login_page__logo'
          style={{
            backgroundImage: `url(https://textback.ai/wp-content/uploads/2019/09/Textback_logo-e1568115685184.png)`,
            cursor: 'pointer',
          }}
          onClick={(e) => {
            e.preventDefault();
            history.push(AppRoutes.HomePage);
          }}
        ></div>
        <div className='container'>
          <div className='login form'>
            <div className='center' style={{ width: '100%', height: '100%' }}>
              <div className='center flex-column tw-gap-[15px]' style={{ width: '350px' }}>
                <div className='header'>RESET PASSWORD</div>

                {needResetPassword && (
                  <NewDesign.Alert color='primary' className='mb-0'>
                    Your password has <b>EXPIRED</b>! <br />
                    To improve protection and safety, it must be changed!
                  </NewDesign.Alert>
                )}

                <Formik
                  validateOnBlur={false}
                  validateOnChange={false}
                  onSubmit={handleOnSubmit}
                  initialValues={initialValues}
                  validationSchema={validationResetPassword}
                >
                  {({ isSubmitting, values }) => {
                    return (
                      <Fragment>
                        <Form className='center tw-gap-[20px] flex-column tw-w-full mt-2'>
                          <div className=' justify-content-center tw-gap-[8px] flex-column tw-w-full'>
                            <Field
                              name='password'
                              type='password'
                              component={InputField}
                              label='Password'
                              required
                              placeholder='Input your password'
                            />
                          </div>
                          <div className=' justify-content-center tw-gap-[8px] flex-wrap tw-w-full'>
                            <Field
                              name='passwordConfirm'
                              type='password'
                              component={InputField}
                              required
                              label='Confirm Password'
                              placeholder='Confirm your password'
                            />
                          </div>

                          {error && (
                            <div className='alert alert-danger tw-w-full' role='alert'>
                              {error}
                            </div>
                          )}

                          {success && (
                            <NewDesign.Alert color='success' className='mb-0'>
                              <NewDesign.Typography>
                                Password has been reset successfully!
                                <br /> You'll be redirected to login page in a few seconds...
                              </NewDesign.Typography>
                            </NewDesign.Alert>
                          )}

                          <div className='d-flex tw-gap-[5px] flex-column tw-w-full'>
                            <NewDesign.Button
                              type='submit'
                              className='tw-w-full'
                              isLoading={isSubmitting}
                              disabled={isSubmitting}
                            >
                              Reset Password
                            </NewDesign.Button>
                          </div>
                        </Form>
                      </Fragment>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
          <div
            className='container__background left'
            style={{ backgroundImage: `url(${background})` }}
          ></div>
        </div>
        <div className='copy_right'>Copyright &copy; 2021 &mdash; Textback.ai</div>
      </div>
    </Fragment>
  );
};

export default ResetPasswordV2;
